import { DataBean } from "../../DataBean";


export class GetMaxTicketCode extends DataBean {

    public async getMaxTicketCode(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "Number_getMaxTicketCode_Number", [args]);
    }

}